import { render, staticRenderFns } from "./videoCollections.vue?vue&type=template&id=5d60f516&"
import script from "./videoCollections.vue?vue&type=script&lang=js&"
export * from "./videoCollections.vue?vue&type=script&lang=js&"
import style0 from "./videoCollections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports